module.exports = __webpack_public_path__ + "img/斜面操作台1.bb17c84a.jpg";